import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const AddressUpdateAdminReport = () => {
    const [addressData, setAddressData] = useState([]);
    const tableRef = useRef(null);

    // 🔹 Fetch Address Update Records
    useEffect(() => {
        const fetchAddressData = async () => {
            try {
                const authToken = localStorage.getItem("authToken");

                const response = await fetch(`${API_BASE_URL}/AddressUpdate/GetAddressUpdateRecords`,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        }
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                let data = await response.json();

                data = data.map((record, index) => ({
                    ...record,
                    SrNo: index + 1
                }));

                setAddressData(data);
            } catch (error) {
                console.error('Failed to fetch address update records:', error);
            }
        };

        fetchAddressData();
    }, []);

    // 🔹 Update Status
    const handleStatusChange = async (registrationNo, newStatus) => {
        const comment = prompt("Enter comment for this status change:");
        if (!comment) return;

        try {
            const authToken = localStorage.getItem("authToken");

            const response = await fetch(`${API_BASE_URL}/AddressUpdate/updateStatus/${registrationNo}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: JSON.stringify({ status: newStatus, comment }),
                }
            );

            if (!response.ok) throw new Error("Failed to update status");

            setAddressData(prev =>
                prev.map(row =>
                    String(row.registrationNo) === String(registrationNo)
                        ? { ...row, status: newStatus, comment: comment }
                        : row
                )
            );

            alert("Status updated successfully!");
        } catch (error) {
            console.error("Error updating status:", error);
            alert("Error updating status. Please try again.");
        }
    };

    // 🔹 Download Action (Blob from Backend for both Form and Document)
    const downloadAction = async (registrationNo, type) => {
        try {
            const authToken = localStorage.getItem("authToken");
            const endpoint = type === "form"
                ? `${API_BASE_URL}/AddressUpdate/DownloadPdf/${registrationNo}`
                : `${API_BASE_URL}/AddressUpdate/DownloadDocument/${registrationNo}`;

            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to download: ${response.status}`);
            }

            const blob = await response.blob();
            const contentType = response.headers.get("Content-Type");
            
            // Determine file extension and name
            let extension = contentType?.split("/")[1] || "pdf";
            if (extension.includes(";")) extension = extension.split(";")[0];
            
            let fileName = type === "form" 
                ? `AddressUpdate_Form_${registrationNo}.pdf` 
                : `AddressUpdate_Doc_${registrationNo}.${extension}`;

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            
        } catch (error) {
            console.error("Download error:", error);
            alert("Failed to download file.");
        }
    };

    // 🔹 Init DataTable
    useEffect(() => {
        if (tableRef.current && addressData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true,
                data: addressData,
                columns: [
                    { data: 'SrNo', title: 'Sr No' },
                    { data: 'startDate', title: 'Date' },
                    { data: 'registrationNo', title: 'Registration No' },
                    { data: 'aadhaarNumber', title: 'Aadhaar No' },
                    {
                        data: 'status',
                        title: 'Status',
                        render: function (data, type, row) {
                            return `
                                <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                                    <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                                    <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                                    <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                                    <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                                </select>
                            `;
                        }
                    },
                    { data: 'comment', title: 'Comment' },
                    {
                        data: null,
                        title: "Document",
                        render: function (data, type, row) {
                            return `<button class="btn btn-sm btn-success download-doc-btn" data-id="${row.registrationNo}">Download</button>`;
                        }
                    },
                    {
                        data: null,
                        title: "Submitted Form",
                        render: function (data, type, row) {
                            return `<button class="btn btn-sm btn-primary download-form-btn" data-id="${row.registrationNo}">Download PDF</button>`;
                        }
                    }
                ]
            });

            // Handlers
            $(tableRef.current).off("change", ".status-dropdown").on("change", ".status-dropdown", function () {
                handleStatusChange($(this).data("id"), $(this).val());
            });

            $(tableRef.current).off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
                downloadAction($(this).data("id"), "document");
            });

            $(tableRef.current).off('click', '.download-form-btn').on('click', '.download-form-btn', function () {
                downloadAction($(this).data("id"), "form");
            });

            return () => {
                table.destroy();
                $(tableRef.current).off("change", ".status-dropdown");
                $(tableRef.current).off('click', '.download-doc-btn');
                $(tableRef.current).off('click', '.download-form-btn');
            };
        }
    }, [addressData]);

    return (
        <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
        >
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Registration No</th>
                    <th>Aadhaar No</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Document</th>
                    <th>Submitted Form</th>
                </tr>
            </thead>
        </table>
    );
};

export default AddressUpdateAdminReport;
